<template>
<div>
  <top-navigation></top-navigation>
  <div>
    <div class="container">
      <div class="row">
        <left-sidebar :showBasket=true :showProductCategoryNavigation=true></left-sidebar>
        <div class="col-sm-9 padding-right content-page">
          <div class="features_items">
              <h2><i class="fa fa-exclamation-triangle"></i> Sorry!</h2>
              <p>Unfortunately something went wrong and it has not been possible to provide the requested page.</p>
          </div>
          <div class="large-padding"/>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import TopNavigation from '../../components/common/TopNavigation';
import LeftSidebar from '../../components/common/LeftSidebar';

export default {
  name: 'not-found',
  components: {
    'top-navigation': TopNavigation,
    'left-sidebar': LeftSidebar,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/notfound/Index.vue